import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _styled from "styled-components";
import { TextInput as FlowBiteTextInput } from 'flowbite-react';
import { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

var generateEmptyArray = function generateEmptyArray(length) {
  return Array.from({
    length: length
  }, function () {
    return '';
  });
};

export var OTPInput = function OTPInput(_ref) {
  var _ref$numberOfDigits = _ref.numberOfDigits,
      numberOfDigits = _ref$numberOfDigits === void 0 ? 6 : _ref$numberOfDigits,
      onChange = _ref.onChange,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      value = _ref.value,
      _ref$isSuccess = _ref.isSuccess,
      isSuccess = _ref$isSuccess === void 0 ? false : _ref$isSuccess,
      customTextFieldStyles = _ref.customTextFieldStyles;
  var inputRefs = useRef([]);
  var initialOtpDigits = useMemo(function () {
    return generateEmptyArray(numberOfDigits);
  }, [numberOfDigits]);

  var _useState = useState(initialOtpDigits),
      otpDigits = _useState[0],
      setOtpDigits = _useState[1];

  useEffect(function () {
    var updatedOtpDigits = generateEmptyArray(numberOfDigits);

    if (value && !isNaN(Number(value))) {
      value.split('').forEach(function (digit, index) {
        updatedOtpDigits[index] = digit;
      });
    }

    setOtpDigits(updatedOtpDigits);
  }, [numberOfDigits, value]);
  var handleInputChange = useCallback(function (index, value) {
    if (isNaN(Number(value))) return;

    var updatedOtpDigits = _toConsumableArray(otpDigits);

    updatedOtpDigits[index] = value;
    setOtpDigits(updatedOtpDigits);

    if (value && index < numberOfDigits - 1) {
      var _inputRefs$current;

      (_inputRefs$current = inputRefs.current[index + 1]) === null || _inputRefs$current === void 0 ? void 0 : _inputRefs$current.focus();
    }

    onChange(parseInt(updatedOtpDigits.join('')));
  }, [otpDigits, numberOfDigits, onChange]);
  var handleInputPaste = useCallback(function (e) {
    e.preventDefault();
    var pasteData = e.clipboardData.getData('text/plain');

    if (!isNaN(Number(pasteData))) {
      var updatedOtpDigits = pasteData.split('').slice(0, numberOfDigits);
      setOtpDigits(updatedOtpDigits);
      onChange(parseInt(updatedOtpDigits.join('')));
    }
  }, [numberOfDigits, onChange]);
  var handleInputKeyDown = useCallback(function (e, index) {
    if (e.key === 'Backspace') {
      var updatedDigits = _toConsumableArray(otpDigits);

      updatedDigits[index] = '';
      setOtpDigits(updatedDigits);

      if (index > 0) {
        var _inputRefs$current2;

        (_inputRefs$current2 = inputRefs.current[index - 1]) === null || _inputRefs$current2 === void 0 ? void 0 : _inputRefs$current2.focus();
      }
    }
  }, [otpDigits]);
  return /*#__PURE__*/_jsx(_StyledDiv, {
    children: otpDigits.map(function (digit, index) {
      return /*#__PURE__*/_jsx(TextField, {
        type: "text",
        maxLength: 1,
        value: digit,
        onChange: function onChange(e) {
          return handleInputChange(index, e.target.value);
        },
        onPaste: handleInputPaste,
        onKeyDown: function onKeyDown(e) {
          return handleInputKeyDown(e, index);
        },
        ref: function ref(input) {
          return inputRefs.current[index] = input;
        },
        variant: variant,
        isSuccess: isSuccess,
        $customTextFieldStyles: customTextFieldStyles
      }, index);
    })
  });
};

var TextField = /*#__PURE__*/_styled(FlowBiteTextInput).withConfig({
  displayName: "formotp-input__TextField",
  componentId: "sc-191giez-0"
})(["", " input{", " ", " ", " ", " ", "}"], {
  "display": "flex",
  "outline": "2px solid transparent",
  "outlineOffset": "2px"
}, {
  "boxSizing": "border-box",
  "height": "3.688rem",
  "width": "2.438rem",
  "maxWidth": "2.438rem",
  "borderRadius": "0.938rem",
  "borderStyle": "none",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
  "textAlign": "center",
  "fontSize": "1rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))",
  "outline": "2px solid transparent",
  "outlineOffset": "2px",
  ":focus": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(229 231 235 / var(--tw-ring-opacity))"
  }
}, function (_ref2) {
  var variant = _ref2.variant;
  return variant === 'primary' && {
    "::placeholder": {
      "--tw-text-opacity": "1",
      "color": "rgb(156 163 175 / var(--tw-text-opacity))"
    }
  };
}, function (_ref3) {
  var variant = _ref3.variant;
  return variant === 'error' && {
    "--tw-bg-opacity": "1 !important",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity)) !important",
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(186 0 31 / var(--tw-ring-opacity))",
    "::placeholder": {
      "--tw-text-opacity": "1",
      "color": "rgb(186 0 31 / var(--tw-text-opacity))"
    },
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(186 0 31 / var(--tw-ring-opacity))"
    }
  };
}, function (_ref4) {
  var isSuccess = _ref4.isSuccess;
  return isSuccess && {
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(0 119 64 / var(--tw-ring-opacity))",
    "::placeholder": {
      "--tw-text-opacity": "1",
      "color": "rgb(0 119 64 / var(--tw-text-opacity))"
    },
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(0 119 64 / var(--tw-ring-opacity))"
    }
  };
}, function (_ref5) {
  var $customTextFieldStyles = _ref5.$customTextFieldStyles;
  return $customTextFieldStyles;
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "formotp-input___StyledDiv",
  componentId: "sc-191giez-1"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "justifyContent": "center",
  "gap": "0.5rem"
});